import { Text } from 'react-native'
import { StyleSheet, View } from 'react-native'
import { palette } from '../../../../../theme/palette'

const Messages = {
  Correct: ['💃🏻  Good job!', '👑 Yes!', '🙌 Correct!'],
  Wrong: ['❌ Incorrect']
} as const

export const Chip = ({ correct }: { correct: boolean }) => {
  const messages = Messages[correct ? 'Correct' : 'Wrong']
  const message = messages[Math.floor(Math.random() * (messages.length - 1))]
  return (
    <View style={styles.container}>
      <Text>{message}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: palette.white,
    borderRadius: 50,
    paddingHorizontal: 16,
    paddingVertical: 8,
    alignSelf: 'flex-start',
    shadowColor: '#0000001A',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 1,
    shadowRadius: 8
  }
})
